import { nextTick } from 'vue';

/**
 * Set default props for form elements
 *
 */
function formkitDefaultPropsPlugin(node: any) {
  if (node.props.type === 'form') {
    if (node.props.submitBehavior === undefined) {
      node.props.submitBehavior = 'live';
    }
    if (node.props.actions === undefined) {
      node.props.actions = false;
    }
    if (node.props.incompleteMessage === undefined) {
      node.props.incompleteMessage = false;
    }
  }
  generateInputId(node);
}

/**
 * To help QA team to create automation test case
 *
 * @param node
 * @returns void
 */
function generateInputId(node: any) {
  try {
    if (node.props.label && /input(_\d+)+/.test(node.props.id as string)) {
      let inputId = (
        (node.props.label as string).toLowerCase().replaceAll(/[^a-z0-9]/gi, '_') +
        '_' +
        node.props.type
      ).replaceAll(/_+/g, '_');
      let i = 0;
      if (document.querySelector(`[data-test-id=${inputId}]`)) {
        while (document.querySelector(`[data-test-id=${inputId}_${i}]`)) {
          i++;
        }
        inputId = `${inputId}_${i}`;
      }
      node.props.attrs['data-test-id'] = inputId;
      return;
    }
    // Special case for togglebuttons
    if (node.props.type == 'togglebuttons') {
      // wait until it is rendered
      nextTick(() => {
        const togglebuttons = document.querySelectorAll(`#${node.props.id} li>button`);
        if (togglebuttons?.length) {
          togglebuttons.forEach((el, index) => {
            el.setAttribute(
              'data-test-id',
              `${node.props.attrs.testId ?? ''}_${node.props.options?.[index]?.label}_${node.props.options?.[index]?.value}`
                .toLowerCase()
                .replaceAll(' ', '')
            );
          });
        }
      });
    }
  } catch (error) {
    console.warn(error); // do nothing
  }
}

export default formkitDefaultPropsPlugin;
